import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { PureComponent } from 'react';
import { List, Map } from 'immutable';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import styles from '@client/pages/createIFPage/createIFPage.scss';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import {
  valueOrEmptyStr,
  valueOrSpace,
} from '@client/shared/utils/utils/utils';
import FormSectionContainer from '@client/containers/formSectionContainer/FormSectionContainer';
import InputGroup from '@client/components/formComponents/inputGroup/InputGroup';
import DropdownGroup from '@client/components/formComponents/dropdownGroup/DropdownGroup';
import {
  isMemorialFundraiser,
  isSporteventFundraiser,
} from '@client/shared/utils/fundraiserUtils/fundraiserUtils';
import fcfStyles from './formCreateFundraiser.scss';

class FormCreateFundraiser extends PureComponent {
  showMyInfoFormSection = () => {
    const { userInfo } = this.props;
    const firstName = getIn(userInfo, 'given_name');
    const lastName = getIn(userInfo, 'family_name');
    const email = getIn(userInfo, 'email');

    return !firstName || !lastName || !email;
  };

  getEventNamesByFundraiserType = (events, selectedFundraiserType) => {
    if (!events) {
      return List();
    }

    const groupedEventNames = events.filter((event) => {
      return (
        getIn(event, 'fundraiserType', 'fields', 'id') ===
        parseInt(selectedFundraiserType)
      );
    });

    return groupedEventNames.map((entry) => {
      return Map({
        id: getIn(entry, 'slug'),
        name: getIn(entry, 'eventName'),
      });
    });
  };

  componentDidUpdate(prevProps) {
    const { formProps } = this.props;
    const prevFundraiserType = prevProps.formProps.values.fundraiserType;
    const thisFundraiserType = formProps.values.fundraiserType;
    const { events } = this.props;

    const eventNamesByFundraiserType = this.getEventNamesByFundraiserType(
      events,
      thisFundraiserType
    );

    if (prevFundraiserType !== thisFundraiserType) {
      if (isSporteventFundraiser(prevFundraiserType)) {
        formProps.setFieldValue('eventName', undefined);
      }
      if (isSporteventFundraiser(thisFundraiserType)) {
        eventNamesByFundraiserType.map((value) => {
          const id = value.get('id');
          formProps.setFieldValue('eventName', id);
        });
      }
      if (isMemorialFundraiser(prevFundraiserType)) {
        formProps.setFieldValue('memorialFirstName', undefined);
        formProps.setFieldValue('memorialLastName', undefined);
        formProps.setFieldValue('memorialBirthDate', undefined);
        formProps.setFieldValue('memorialDeathDate', undefined);
      }
    }
  }

  render() {
    const { className, formProps, translations, events, fundraiserTypes } =
      this.props;

    const formValues = formProps.values;
    const formErrors = formProps.errors;
    const selectedFundraiserType = formValues.fundraiserType;

    const eventNamesByFundraiserType = this.getEventNamesByFundraiserType(
      events,
      selectedFundraiserType
    );

    return (
      <form
        onSubmit={formProps.handleSubmit}
        className={`${styles.formCreateFundraiser}${
          className ? ` ${className}` : ''
        }`}
        autoComplete={'off'}
      >
        <h3 className={`${styleHelper.titleMdPrimary} ${styles.title}`}>
          Skapa din insamling
        </h3>
        <FormSectionContainer
          className={styles.formSectionContainerProp}
          number={1}
          title={'Skapa insamling'}
        >
          {this.showMyInfoFormSection() && (
            <div className={fcfStyles.myInfoContainer}>
              <p className={styles.subTitle}>
                Vänligen fyll i dina uppgifter för att skapa en insamling.
              </p>
              <div className={styleHelper.formRow}>
                <InputGroup
                  labelText={'Förnamn*'}
                  name={'firstName'}
                  value={valueOrEmptyStr(formValues.firstName)}
                  onChange={formProps.handleChange}
                  onBlur={formProps.handleBlur}
                  errorLabel={formErrors.firstName}
                />
                <InputGroup
                  labelText={'Efternamn*'}
                  name={'lastName'}
                  value={valueOrEmptyStr(formValues.lastName)}
                  onChange={formProps.handleChange}
                  onBlur={formProps.handleBlur}
                  errorLabel={formErrors.lastName}
                />
              </div>
              <div className={styleHelper.formRow}>
                <InputGroup
                  labelText={'E-post*'}
                  name={'email'}
                  value={valueOrEmptyStr(formValues.email)}
                  onChange={formProps.handleChange}
                  onBlur={formProps.handleBlur}
                  errorLabel={formErrors.email}
                  size="0.49"
                />
              </div>
            </div>
          )}

          <p className={styles.subTitle}>
            Vänligen fyll i information om din insamling.
          </p>
          <div className={styleHelper.formRow}>
            <InputGroup
              labelText={'Namn på min insamling*'}
              name={'title'}
              value={valueOrEmptyStr(formValues.title)}
              onChange={formProps.handleChange}
              onBlur={formProps.handleBlur}
              errorLabel={formErrors.title}
            />
            <InputGroup
              labelText={'Insamlingsmål*'}
              name={'targetAmount'}
              value={valueOrEmptyStr(formValues.targetAmount)}
              onChange={formProps.handleChange}
              onBlur={formProps.handleBlur}
              errorLabel={formErrors.targetAmount}
            />
          </div>

          <div className={styleHelper.formRow}>
            <div className={fcfStyles.dropdownContainer}>
              <DropdownGroup
                name="fundraiserType"
                label="Insamlingstyp"
                optionValues={fundraiserTypes}
                onChange={formProps.handleChange}
                onBlur={formProps.handleBlur}
                initialValue={formProps.initialValues.fundraiserType}
                errorLabel={formErrors.fundraiserType}
              />
            </div>

            <div className={fcfStyles.descriptionBoxContainer}>
              <div className={fcfStyles.descriptionBox}>
                <h2>Insamling</h2>
                <p>Starta en personlig insamling till forskningen.</p>
                <h2>Minnesfond</h2>
                <p>En hyllning till någon som gått bort.</p>
                <h2>Cykelmiljonen</h2>
                <p>Insamlingen där alla kan vara med och cykla ihop pengar.</p>
              </div>
            </div>
          </div>

          {eventNamesByFundraiserType &&
            eventNamesByFundraiserType.size > 0 && (
              <div className={styleHelper.formRow}>
                <div className={fcfStyles.dropdownContainer}>
                  <DropdownGroup
                    name="eventName"
                    label="Event"
                    optionValues={eventNamesByFundraiserType}
                    onChange={formProps.handleChange}
                    onBlur={formProps.handleBlur}
                    initialValue={formValues.eventName}
                    errorLabel={formErrors.eventName}
                  />
                </div>
              </div>
            )}

          {selectedFundraiserType && parseInt(selectedFundraiserType) === 2 && (
            <div className={styles.memorialSection}>
              <p>Personen du vill tillägna minnesfonden till:</p>
              <div className={styleHelper.formRow}>
                <InputGroup
                  name="memorialFirstName"
                  labelText="Förnamn*"
                  onChange={formProps.handleChange}
                  onBlur={formProps.handleBlur}
                  initialValue={formValues.memorialFirstName}
                  errorLabel={formErrors.memorialFirstName}
                />
                <InputGroup
                  name="memorialLastName"
                  labelText="Efternamn*"
                  onChange={formProps.handleChange}
                  onBlur={formProps.handleBlur}
                  initialValue={formValues.memorialLastName}
                  errorLabel={formErrors.memorialLastName}
                />
              </div>
              <div className={styleHelper.formRow}>
                <InputGroup
                  name="memorialBirthDate"
                  labelText="Födelsedatum*"
                  placeholder={'YYYY-MM-DD'}
                  onChange={formProps.handleChange}
                  onBlur={formProps.handleBlur}
                  maxLength={10}
                  initialValue={formValues.memorialBirthDate}
                  errorLabel={formErrors.memorialBirthDate}
                />
                <InputGroup
                  name="memorialDeathDate"
                  labelText="Dödsdatum*"
                  placeholder={'YYYY-MM-DD'}
                  onChange={formProps.handleChange}
                  onBlur={formProps.handleBlur}
                  maxLength={10}
                  initialValue={formValues.memorialDeathDate}
                  errorLabel={formErrors.memorialDeathDate}
                />
              </div>
            </div>
          )}

          <div className={`${styles.submitContainer}`}>
            <button
              className={`${styleHelper.btnPrimaryLg} ${styles.btnSubmit}`}
              type="submit"
            >
              Gå vidare
            </button>
          </div>
        </FormSectionContainer>
        <span className={`${styles.requiredInfoText}`}>
          {getIn(translations, 'formAsterisk')}
        </span>
      </form>
    );
  }
}

FormCreateFundraiser.propTypes = {
  className: PropTypes.string,
  formProps: PropTypes.object,
  translations: ImmutablePropTypes.map,
  location: PropTypes.object,
  pageData: ImmutablePropTypes.map,
  userInfo: ImmutablePropTypes.map,
  events: ImmutablePropTypes.list,
  fundraiserTypes: ImmutablePropTypes.list,
};

export default FormCreateFundraiser;
